export enum AssetType {
    Residential = 1,
    Office = 2,
    House = 3,
    Warehouse = 4,
    RetailShop = 5,
    RetailBuilding = 6,
    Parking = 7
}